import Parameter from './Parameter';
import { EnumLayout } from './Enums/EnumLayout';
import Report from './Report';
import ReportParameters from './ReportParameters';
export default class FieldSet {
    // Titre qui s'affiche
    public Title: string;
    
    // Nom du fieldSet
    public Name: string;
    
    // Column ou Row
    public Layout: EnumLayout;

    // Type du fieldSets pas de vrai utilité
    public Type: string;

    // Si le fieldSet est checkable ou non
    public CheckboxToggle: boolean | null;

    // Les des paramètres enfants
    public Parameters: Parameter[];

    /**
     * Constructeur FieldSet
     * @param Title 
     * @param Name 
     * @param Layout 
     * @param Type 
     * @param CheckboxToggle 
     * @param Parameters 
     */
    public constructor(Title: string = '', Name: string = '', Layout: EnumLayout = EnumLayout.Column, Type: string = 'FieldSet', CheckboxToggle: boolean = null, Parameters: Parameter[] = []) {
        this.Title = Title;
        this.Name = Name;
        this.Layout = Layout;
        this.Type = Type;
        this.CheckboxToggle = CheckboxToggle;
        this.Parameters = Parameters;
    }

    //#region Méthode statique

    // Registre pour stocker les sous-classes
    private static subclasses: typeof FieldSet[] = [this];

    // Enregistrer une sous-classe
    static registerSubclass(subclass: typeof FieldSet): void {
        this.subclasses.push(subclass);
    }

    // Méthode pour récupérer toutes les sous-classes
    static getSubclasses(): typeof FieldSet[] {
        return this.subclasses;
    }

    //#endregion

    //#region ReportEditor

    /**
     * Créer des FieldSets Temporaire
     * @param report Report en cours
     */
    public createGhost(ReportParameter: ReportParameters){
        // Part de la fin pour ne pas rajouter d'index dans les FieldSets
        for(let x = ReportParameter.FieldSets.length; x > 0; x--){
            // Reflect.construct appel le constructeur
            ReportParameter.FieldSets.splice(x, 0, new FieldSet())
        }

        // Créer le premier FieldSet temporaire
        ReportParameter.FieldSets.unshift(new FieldSet())
    }

    /**
     * Supprimer tous les FieldSets Temporaire
     * @param report Report en cours
     */
    public deleteGhost(ReportParameter: ReportParameters){
        ReportParameter.FieldSets.filter(u => u.equalsFieldSet()).forEach(u => {
            ReportParameter.FieldSets.splice(ReportParameter.FieldSets.indexOf(u), 1);
        })
    }

    public save(ReportParameter: ReportParameters, selectedFieldSetIndex: number){
        ReportParameter.FieldSets.splice(selectedFieldSetIndex, 0, this);
        this.deleteGhost(ReportParameter);
    }

    //#endregion

    public getClassName() {
        return "FieldSet";
    }

    public fromXml(xml: string){
        if(xml){
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(xml, "application/xml");

            let xmlFieldSet = xmlDoc.querySelector('FieldSet');

            if(xmlFieldSet != null){
                this.Title = xmlFieldSet.getAttribute('Title') || '';
                this.Name = xmlFieldSet.getAttribute('Name') || '';
                this.Layout = this.parseLayout(xmlFieldSet.getAttribute('Layout')) || EnumLayout.Column;
                this.Type = xmlFieldSet.getAttribute('Type') || '';
                if(xmlFieldSet.getAttribute('CheckboxToggle'))
                    this.CheckboxToggle = xmlFieldSet.getAttribute('CheckboxToggle') === 'true' ? true : false;

                if(xmlFieldSet.querySelectorAll('Parameter')){
                    this.Parameters = [];
                    xmlFieldSet.querySelectorAll('Parameter').forEach((param) => {
                        this.Parameters.push(new Parameter().fromXml(param.outerHTML));
                    });
                }
            }

            return this;
        }
    }

    public equalsFieldSet(other: FieldSet = new FieldSet()): boolean{
        return (this.Title === other.Title 
        && this.Name === other.Name 
        && this.Layout === other.Layout 
        && this.Type === other.Type 
        && this.CheckboxToggle === other.CheckboxToggle);
    }

    /**
     *
     * @returns Propriété filtrées pour la création d'un objet FieldSet
     */
    public getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    public parseLayout(value: string){
        return EnumLayout[value];
    }

    // Créations des clé pour filtrer les propriété de FieldSets
    private keysToFilter: string[] =  ['Title', 'Layout', 'CheckboxToggle'];

    public create(): FieldSet{
        return new FieldSet(this.Title, this.Name, this.Layout, this.Type, this.CheckboxToggle, this.Parameters)
    }
}